import config from "../config.json";
import axios from "axios";

const apiClient = axios.create();

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.response) {
      console.error("No response received:", error.request);
      return Promise.reject(error);
    }

    const { status, config } = error.response;

    switch (status) {
      case 401:
        console.warn("Unauthorized: Attempting token refresh");

        if (config._retry) {
          return Promise.reject(error);
        }

        const newToken = await refreshAccessToken();
        if (newToken) {
          config.headers["Authorization"] = `Bearer ${newToken}`;
          return apiClient(config);
        }
        break;
      case 403:
        console.warn("Forbidden: ", error.response);
        break;
      case 404:
        console.warn("Not Found: ", error.response);
        break;
      case 500:
        console.warn("Internal Server Error: ", error.response);
        break;
      default:
        console.warn("Error: ", error.response);
        break;
    }

    return Promise.reject(error);
  }
);

const getAccessToken = async () => {
  let token = localStorage.getItem("tkd");

  if (!token) {
    token = await refreshAccessToken();
  }

  return token;
};

const getUserEmail = () => {
  try {
    const encodedEmail = localStorage.getItem("emd");
    return encodedEmail ? atob(encodedEmail) : "";
  } catch (error) {
    console.error("Error decoding email:", error);
    return "";
  }
};

const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem("rfd");

  if (!refreshToken) {
    console.error("No refresh token available");
    handleRedirectLogin();
    return null;
  }
  

  let url = `${config.API_URL}/auths/refresh-token`;
  let headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(
      url,
      JSON.stringify({
        refresh_token: refreshToken,
      }),
      {
        headers,
        timeout: config.API_CONNECTION_TIMEOUT,
      }
    );

    if (!response?.data?.is_success || !response?.data?.result) {
      handleRedirectLogin();
      return null;
    }

    localStorage.setItem("tkd", response?.data?.result?.token?.access_token);
    localStorage.setItem("rfd", response?.data?.result?.token?.refresh_token);
    return response?.data?.result?.token?.access_token;
  } catch (error) {
    handleRedirectLogin();
    console.error("Token refresh failed:", error);
    return null;
  }
};

const handleRedirectLogin = () => {
  localStorage.removeItem("tkd");
  localStorage.removeItem("rfd");

  // เช็คว่าอยู่หน้า messenger หรือเปล่า
  if (window.location.pathname.startsWith('/messenger')) {
      window.location.href = "/login";
  } else {
      window.location.href = "/login";
  }
};

export { getAccessToken, getUserEmail, apiClient };
